module.exports = __webpack_public_path__ + "img/battery.cf60eb7c.png";